import { Link } from "react-router-dom";

import { useVariants } from "../lib/api";

export default function HomePage() {
  const { data, isLoading, isError, error } = useVariants();

  if (isLoading) {
    return <p className="text-slate-500">Loading fleets…</p>;
  }
  if (isError) {
    return (
      <div className="rounded border border-red-200 bg-red-50 p-4 text-sm text-red-900">
        Failed to load fleets: {(error as Error).message}
      </div>
    );
  }

  return (
    <section>
      <h1 className="mb-4 text-2xl font-semibold">Fleets</h1>
      <ul className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {data?.variants.map((v) => (
          <li key={v.variant_id}>
            <Link
              to={`/fleet/${v.variant_id}`}
              className="block rounded border border-slate-200 bg-white p-4 hover:border-slate-400 hover:shadow"
            >
              <div className="font-medium text-slate-900">{v.name}</div>
              <div className="mt-1 text-xs text-slate-500">
                {v.config_ref} · {v.tails_count} tails
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
